import {Component, OnDestroy, OnInit} from '@angular/core';
import {ReplaySubject} from "rxjs";
import {ReceivablesPaymentImportRow} from "../../../shared/interface/receivables-payment-import-row";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {LicensedAgent} from "../../../shared/interface/licensed-agent";
import {ActivatedRoute} from "@angular/router";
import {ReceivablesPaymentImportRowService} from "../../../shared/services/receivables-payment-import-row.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import {AuthService} from "../../../shared/services/auth.service";
import {takeUntil} from "rxjs/operators";
import {HttpErrorResponse} from "@angular/common/http";
import {LicensedAgentService} from "../../../shared/services/licensed-agent.service";

@Component({
  selector: 'app-licensed-details',
  templateUrl: './licensed-details.component.html',
  styleUrls: ['./licensed-details.component.scss']
})
export class LicensedDetailsComponent implements OnInit, OnDestroy {

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  licensedId: string;
  licensedObject?: LicensedAgent;
  licensed: ReplaySubject<LicensedAgent> = new ReplaySubject<LicensedAgent>(1);
  userPermissions: ReplaySubject<UserPermissions>;
  modify = false;

  constructor(
    private route: ActivatedRoute,
    private licensedAgentService: LicensedAgentService,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private auth: AuthService,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.route.params
      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        this.licensedId = params.id;
        this.loadLicensed();
      });
  }
  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  loadLicensed(): void {
    this.licensedAgentService.get(this.licensedId).subscribe((licensed: LicensedAgent) => {
      this.licensed.next(licensed);
      this.licensedObject = licensed;
    }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych', error.status.toString(), {
        duration: 2000
      });
    });
  }

}
